export const LOAD_SESSION = 'LOAD_SESSION';
export const SET_THEME = 'SET_THEME';

export const loadSession = () => ({ type: LOAD_SESSION });

export const setTheme = theme => ({ type: SET_THEME, payload: { theme } });
